'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var tableCell = require('./table-cell-3a562957.js');

var cellWidthStyles = {
    sm: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    width: 50px;\n  "], ["\n    width: 50px;\n  "]))),
    md: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    width: 100px;\n  "], ["\n    width: 100px;\n  "]))),
};
var ActionsTableCell = styled__default(tableCell.TableCell)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  &.root {\n    padding: 0;\n    vertical-align: middle;\n    text-align: center;\n\n    ", "\n  }\n\n  &.head {\n    text-align: start;\n    padding: 16px;\n  }\n"], ["\n  &.root {\n    padding: 0;\n    vertical-align: middle;\n    text-align: center;\n\n    ", "\n  }\n\n  &.head {\n    text-align: start;\n    padding: 16px;\n  }\n"])), function (_a) {
    var _b = _a.width, width = _b === void 0 ? 'md' : _b;
    return cellWidthStyles[width];
});
var templateObject_1, templateObject_2, templateObject_3;

exports.ActionsTableCell = ActionsTableCell;
